/**
 * @generated SignedSource<<a520beb4129fa078533e7823cd52d0e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type uiMetaField_TestSite$data = {
  readonly hdLogo: {
    readonly __typename: "SiteSettingsUiMetaField";
    readonly classes: ReadonlyArray<string | null | undefined> | null | undefined;
    readonly conditions: ReadonlyArray<string | null | undefined> | null | undefined;
    readonly id: string | null | undefined;
    readonly mediaItem: {
      readonly description: string | null | undefined;
      readonly id: string;
      readonly mediaDetails: {
        readonly sizes: ReadonlyArray<{
          readonly name: string | null | undefined;
          readonly sourceUrl: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly mediaItemUrl: string | null | undefined;
      readonly mimeType: string | null | undefined;
    } | null | undefined;
    readonly style: string | null | undefined;
    readonly value: string | null | undefined;
  } | null | undefined;
  readonly hdLogoText: {
    readonly __typename: "SiteSettingsUiMetaField";
    readonly classes: ReadonlyArray<string | null | undefined> | null | undefined;
    readonly conditions: ReadonlyArray<string | null | undefined> | null | undefined;
    readonly id: string | null | undefined;
    readonly mediaItem: {
      readonly description: string | null | undefined;
      readonly id: string;
      readonly mediaDetails: {
        readonly sizes: ReadonlyArray<{
          readonly name: string | null | undefined;
          readonly sourceUrl: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly mediaItemUrl: string | null | undefined;
      readonly mimeType: string | null | undefined;
    } | null | undefined;
    readonly style: string | null | undefined;
    readonly value: string | null | undefined;
  } | null | undefined;
  readonly id: string | null | undefined;
  readonly " $fragmentType": "uiMetaField_TestSite";
};
export type uiMetaField_TestSite$key = {
  readonly " $data"?: uiMetaField_TestSite$data;
  readonly " $fragmentSpreads": FragmentRefs<"uiMetaField_TestSite">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  },
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "classes",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "conditions",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "style",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "MediaItem",
    "kind": "LinkedField",
    "name": "mediaItem",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mediaItemUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mimeType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MediaDetails",
        "kind": "LinkedField",
        "name": "mediaDetails",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MediaSize",
            "kind": "LinkedField",
            "name": "sizes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sourceUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "uiMetaField_TestSite",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SiteSettingsUiMetaField",
      "kind": "LinkedField",
      "name": "hdLogoText",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SiteSettingsUiMetaField",
      "kind": "LinkedField",
      "name": "hdLogo",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    }
  ],
  "type": "SiteSettings",
  "abstractKey": null
};
})();

(node as any).hash = "a3db418f598ae80392c86da39ed8895d";

export default node;
